import React from 'react';
import { ButtonPrimary } from '../../../../../../../components';
import styles from './ActionButtons.module.scss';

type ActionButtonsProps = {
  onCancel: React.MouseEventHandler<HTMLButtonElement>;
  onSave: React.MouseEventHandler<HTMLButtonElement>;
  pendingItems: number;
};

export const ActionButtons = ({ onCancel, onSave, pendingItems }: ActionButtonsProps) => {
  return (
    <div className={styles['action-buttons']}>
      <div className={styles['right-buttons']}>
        <ButtonPrimary type="reset" theme="ghost" onClick={onCancel} disabled={pendingItems === 0}>
          DESCARTAR ALTERAÇÕES
        </ButtonPrimary>
        <ButtonPrimary type="submit" onClick={onSave} disabled={pendingItems !== 1}>
          SALVAR
        </ButtonPrimary>
      </div>
    </div>
  );
};
